import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bottomSheet", "backdrop", "sheet"]
  static values = {
    courseUuid: String,
    lessonId: Number
  }

  showWhyThisVideo() {
    const bottomSheet = this.bottomSheetTarget
    const backdrop = this.backdropTarget
    const sheet = this.sheetTarget

    // Enable pointer events
    bottomSheet.classList.remove("pointer-events-none")

    // Trigger animation on next frame
    requestAnimationFrame(() => {
      backdrop.classList.remove("opacity-0")
      backdrop.classList.add("opacity-50", "pointer-events-auto")
      sheet.classList.remove("translate-y-full")
      sheet.classList.add("translate-y-0")
    })

    // Prevent body scroll when bottom sheet is open
    document.body.style.overflow = "hidden"
  }

  hideWhyThisVideo() {
    const bottomSheet = this.bottomSheetTarget
    const backdrop = this.backdropTarget
    const sheet = this.sheetTarget

    // Trigger hide animation
    backdrop.classList.remove("opacity-50", "pointer-events-auto")
    backdrop.classList.add("opacity-0")
    sheet.classList.remove("translate-y-0")
    sheet.classList.add("translate-y-full")

    // Wait for animation to complete before hiding
    setTimeout(() => {
      bottomSheet.classList.add("pointer-events-none")
    }, 300)

    // Restore body scroll
    document.body.style.overflow = ""
  }

  async markAsComplete() {
    try {
      // Mark the current lesson as complete
      const response = await fetch(`/courses/${this.courseUuidValue}/lessons/${this.lessonIdValue}/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        // Reload the page to show completed state
        window.location.reload()
      } else {
        console.error('Failed to mark lesson as complete')
      }
    } catch (error) {
      console.error('Error completing lesson:', error)
    }
  }
}
